/* * @Author: ligai  */
let project = window.fe.project
if (project === 'purchaser') {
  project = 'purchaseContract'
}
const unit = {
  // 单位列表
  enableUnitList: {
    url: `${project}/unit/component/enableUnitList`,
    type: 'post'
  },
  // 单位校验禁用
  validate: {
    url: `${project}/unit/component/validate`,
    type: 'get'
  }
}
export default unit
